// extracted by mini-css-extract-plugin
export default {"container":"index_container__u06sg","mainPanel":"index_mainPanel__VcEfQ","selectedPanel":"index_selectedPanel__PBeCb"};